import { createSelector } from 'reselect';
import { getSelectedCell as getSelected } from '../ui';
import { chain, value, map, filter, uniq } from 'lodash';

export function getCells(state) {
  return state.cells.cells;
}

export const getSelectedCell = createSelector(
  getCells,
  getSelected,
  (cells, selected) => (
    cells[selected.ascendancy]
  )
)

export const getCellColors = createSelector(
  getCells,
  (cells) => {
    const backgrounds = chain(cells).map('background').filter().map(c => c.toLowerCase()).uniq().value();
    const textColors = chain(cells).map('textColor').filter().map(c => c.toLowerCase()).uniq().value();
    const bandColors = chain(cells).map('bandColor').filter().map(c => c.toLowerCase()).uniq().value();

    return uniq([...backgrounds, ...textColors, ...bandColors]);
  }
)


// WEBPACK FOOTER //
// ./src/core/cells/selectors.js